import logo from '../assets/va-logo.png';

/** The Visual Artform logo: blue disc with the light-blue VA mark (brand/va-logo.png, sized by npm run brand). */
export function VAMark({ className, title = 'Visual Artform' }: { className?: string; title?: string }) {
  return <img className={className} src={logo} alt={title} draggable={false} />;
}

export function BrandLockup() {
  return (
    <>
      <VAMark className="brand-mark" />
      <span className="brand-name">
        VA Plugin Store
        <span>by Visual Artform</span>
      </span>
    </>
  );
}
